var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcs1White(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "46px",
    viewBox: "0 0 32 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CCS 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-IOS",
    stroke: "none",
    strokeWidth: 1,
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home/Search-Copy",
    transform: "translate(-242.000000, -395.000000)",
    stroke: "#020303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(36.000000, 373.488281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CCS-1",
    transform: "translate(207.000000, 22.511719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.673,14.837 C29.673,23.031 23.03,29.674 14.836,29.674 C6.642,29.674 0,23.031 0,14.837 C0,6.643 6.642,0 14.836,0 C23.03,0 29.673,6.643 29.673,14.837 Z",
    id: "Stroke-1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4865,8.9069 C12.4865,10.8759 10.8905,12.4719 8.9215,12.4719 C6.9525,12.4719 5.3555,10.8759 5.3555,8.9069 C5.3555,6.9379 6.9525,5.3419 8.9215,5.3419 C10.8905,5.3419 12.4865,6.9379 12.4865,8.9069 Z",
    id: "Stroke-3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.317,8.9069 C24.317,10.8759 22.721,12.4719 20.752,12.4719 C18.783,12.4719 17.186,10.8759 17.186,8.9069 C17.186,6.9379 18.783,5.3419 20.752,5.3419 C22.721,5.3419 24.317,6.9379 24.317,8.9069 Z",
    id: "Stroke-5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4017,22.8442 C18.4017,24.8132 16.8057,26.4092 14.8367,26.4092 C12.8677,26.4092 11.2707,24.8132 11.2707,22.8442 C11.2707,20.8752 12.8677,19.2792 14.8367,19.2792 C16.8057,19.2792 18.4017,20.8752 18.4017,22.8442 Z",
    id: "Stroke-7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7222,17.6582 C24.7222,18.7322 23.8512,19.6032 22.7772,19.6032 C21.7032,19.6032 20.8332,18.7322 20.8332,17.6582 C20.8332,16.5842 21.7032,15.7132 22.7772,15.7132 C23.8512,15.7132 24.7222,16.5842 24.7222,17.6582 Z",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8401,17.6582 C8.8401,18.7322 7.9691,19.6032 6.8951,19.6032 C5.8211,19.6032 4.9511,18.7322 4.9511,17.6582 C4.9511,16.5842 5.8211,15.7132 6.8951,15.7132 C7.9691,15.7132 8.8401,16.5842 8.8401,17.6582 Z",
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.546,37.721 C23.546,39.322 22.248,40.62 20.647,40.62 C19.046,40.62 17.748,39.322 17.748,37.721 C17.748,36.12 19.046,34.822 20.647,34.822 C22.248,34.822 23.546,36.12 23.546,37.721 Z",
    id: "Stroke-13",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9249,37.721 C11.9249,39.322 10.6269,40.62 9.0259,40.62 C7.4249,40.62 6.1269,39.322 6.1269,37.721 C6.1269,36.12 7.4249,34.822 9.0259,34.822 C10.6269,34.822 11.9249,36.12 11.9249,37.721 Z",
    id: "Stroke-15",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0944,43.015 L7.5784,43.015 C4.6544,43.015 2.2844,40.645 2.2844,37.721 C2.2844,34.797 4.6544,32.427 7.5784,32.427 L22.0944,32.427 C25.0184,32.427 27.3884,34.797 27.3884,37.721 C27.3884,40.645 25.0184,43.015 22.0944,43.015 Z",
    id: "Stroke-17",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7959,37.7965 C20.7539,37.8815 20.6519,37.9155 20.5669,37.8745 C20.4829,37.8325 20.4479,37.7295 20.4899,37.6455 C20.5309,37.5605 20.6339,37.5265 20.7179,37.5675 C20.8029,37.6095 20.8379,37.7115 20.7959,37.7965 Z",
    id: "Stroke-19",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1832,37.7965 C9.1412,37.8815 9.0392,37.9155 8.9542,37.8745 C8.8702,37.8325 8.8352,37.7295 8.8772,37.6455 C8.9182,37.5605 9.0212,37.5265 9.1052,37.5675 C9.1902,37.6095 9.2252,37.7115 9.1832,37.7965 Z",
    id: "Stroke-21",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcs1White);
export default __webpack_public_path__ + "static/media/CCS1White.1789b5664ef34b5d0068f98e3cac91e7.svg";
export { ForwardRef as ReactComponent };